import { Link, useNavigate } from "react-router-dom";

const RefundPolicy = () => {
  const navigate = useNavigate();

  const headingStyle = {
    color: "#1e3a8a",
    marginTop: "32px",
    marginBottom: "12px",
    fontSize: "1.35rem",
  };

  const paragraphStyle = {
    marginBottom: "16px",
    textAlign: "justify",
  };

  const listStyle = {
    paddingLeft: "22px",
    marginBottom: "18px",
  };

  return (
    <div
      className="container"
      style={{
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.8,
        background: "#fff",
        color: "#333",
        padding: "48px",
        maxWidth: "900px",
        margin: "80px auto 40px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        border: "1px solid #e5e5e5",
      }}
    >
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: "10px 18px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: 500,
          marginBottom: "30px",
        }}
      >
        ← Back
      </button>

      {/* Title */}
      <h1
        style={{
          color: "#1f2937",
          borderBottom: "3px solid #2563eb",
          paddingBottom: "12px",
          marginBottom: "20px",
        }}
      >
        Refund Policy
      </h1>

      {/* Effective Date */}
      <div
        style={{
          background: "#f3f4f6",
          padding: "16px 20px",
          borderRadius: "8px",
          marginBottom: "30px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Effective Date:</strong> 25 January 2026
        </p>
      </div>

      <h2 style={headingStyle}>1. Payment of Fees</h2>

      <p style={paragraphStyle}>
        Where applicable, registration or participation fees must be paid
        through the online payment gateway before completing the application
        process.
      </p>

      <h2 style={headingStyle}>2. Currency</h2>

      <p style={paragraphStyle}>
        All fees are charged in <strong>Indian Rupees (INR)</strong>.
      </p>

      <h2 style={headingStyle}>3. Refund Policy</h2>

<ul style={listStyle}>
  <li style={{ marginBottom: "8px" }}>
    If the Customer leaves NIT Calicut before they complete their service
    period, there shall be no entitlement to a refund of paid service fees.
  </li>
  <li style={{ marginBottom: "8px" }}>
    Registration fees and internship fees are non-refundable under any circumstances.
  </li>

  <li style={{ marginBottom: "8px" }}>
    Refunds, if applicable, at the discretion of the Management, will only be
    made to the debit/credit card used for the original transaction. For the
    avoidance of doubt, nothing in this Policy shall require NIT Calicut to
    refund the Fees (or part thereof) unless such Fees (or part thereof) have
    previously been paid.
  </li>
</ul>
      <h2 style={headingStyle}>4. Contact</h2>

      <div
        style={{
          marginTop: "10px",
          padding: "18px",
          background: "#eef6ff",
          borderLeft: "4px solid #2563eb",
          borderRadius: "8px",
        }}
      >
        <strong>Payment Support</strong>
        <br />
        📧 <strong>sip@nitc.ac.in</strong>
      </div>

      {/* Bottom Navigation */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "40px",
          paddingTop: "20px",
          borderTop: "1px solid #ddd",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <Link
          to="/termsandcondition"
          style={{
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 600,
          }}
        >
          ← Terms of Service
        </Link>

        <Link
          to="/privacypolicy"
          style={{
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 600,
          }}
        >
          Privacy Policy →
        </Link>
      </div>
    </div>
  );
};

export default RefundPolicy;
